module.exports = __webpack_public_path__ + "img/video.4e6782c9.png";